import { render } from "./ModalTariff.vue?vue&type=template&id=276e1841"
import script from "./ModalTariff.vue?vue&type=script&lang=js"
export * from "./ModalTariff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__